import {articleOverviewStaticContext} from '../ArticleOverviewStatic.jsx';
import React, {useCallback, useContext, useMemo, useState} from 'react';
import parse from 'html-react-parser';
import {Link} from 'bonprix-design-system';

export default function SeoFooter({seoFooter}) {
    const {texts} = useContext(articleOverviewStaticContext);
    const [showAll, setShowAll] = useState(false);

    const toggleShowAll = useCallback(() => {
        setShowAll((prevShowAll) => !prevShowAll);
    }, []);

    const parsedIntroduction = useMemo(() => parse(seoFooter.introductionAsString), [seoFooter.introductionAsString]);
    const parsedEntries = useMemo(() => parse(seoFooter.entriesAsString), [seoFooter.entriesAsString]);
    const toggleText = showAll ? texts.category_info_show_less : texts.category_info_show_more;

    return (
        <>
            <div className="mt-5 mb-2">
                {parsedIntroduction}
                {showAll && parsedEntries}
            </div>
            <Link component="button" onClick={toggleShowAll}>
                {toggleText}
            </Link>
        </>
    );
}
